export default (role?: { type?: string | null } | null) =>
  role?.type === "ORG_OWNERS";
